export default __webpack_public_path__ + "static/media/Type C main cover.62093469.png";